// Custom pluralization since vue-i18n version 8.0
// https://kazupon.github.io/vue-i18n/guide/pluralization.html#custom-pluralization

// Key - language to use the rule for, `'en'`, in this case
// Value - function to choose right plural form
export const enUS = function(choice, choicesLength) {
  // this === VueI18n instance, so the locale property also exists here
  choice = Math.abs(1 * choice)

  // choicesLength = 1: plural
  if (choicesLength === 2) {
    return 0
  }

  const isOneOrZero = choice === 0 || choice === 1

  // choicesLength = 2: single|plural
  if (choicesLength === 2) {
    return isOneOrZero ? 0 : 1
  }

  if (choice === 0) {
    return 0
  }
  if (choice === 1) {
    return 1
  }
  return 2
}

/*
    const defaultImpl = (_choice: number, _choicesLength: number) => {
      _choice = Math.abs(_choice)

      if (_choicesLength === 2) {
        return _choice ? (_choice > 1 ? 1 : 0) : 1
      }

      return _choice ? Math.min(_choice, 2) : 0
 */
